<p-dialog header="" [(visible)]="displayReturnAdd" [modal]="true" [responsive]="true" [style]="{ width: '80vw' }"
  (onHide)="onDialogClose()">
  <ng-template pTemplate="header">
    <div style="display: flex; justify-content: space-between; width: 100%">
      <h5 style="width: 100%" class="p-mb-0">{{ dialogHeader }}</h5>
      <div>
        <strong [ngClass]="'status-open'" *ngIf="statementMessege">{{statementMessege}}</strong>
      </div>
      @if(type == 'VIEW' && ![3, 4, 5].includes(vendorReturnDetails?.rmaStatusId)){
      <span (click)="editVendorReturn('edit')" class="btnBars">
        <i class="pi pi-pencil"></i>
      </span>
      }
    </div>
  </ng-template>
  <form [formGroup]="returnForm">
    <div class="header">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-pb-0">
          <div class="p-d-flex">
            <span class="p-mt-2 p-mr-2">{{ vendorReturnTemplate?.labels_section[0]?.labelname }}<span
                style="color: red">*</span>:</span>
            <p-dropdown [options]="allReturnTypes" placeholder="Select Return Type..." optionLabel="name"
              formControlName="rmaTypeId" appendTo="body" class="grow-1"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12 p-md-4" *ngIf="vendorReturnTemplate?.labels_section[2]?.isChecked">
          <label>{{ vendorReturnTemplate?.labels_section[2]?.labelname }} <span style="color: red">*</span></label>
          <p-dropdown [options]="rmaLocations" (onChange)="getChangeLocation()" placeholder="Select a Location"
            appendTo="body" optionLabel="label" [showClear]="true" formControlName="warehouseId" [filter]="true"
            [disabled]="type == 'VIEW' || type == 'EDIT'"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-4" *ngIf="vendorReturnTemplate?.labels_section[3]?.isChecked">
          <label>{{ vendorReturnTemplate?.labels_section[3]?.labelname }} <span style="color: red">*</span></label>
          <p-dropdown [options]="allVendorsDD" placeholder="Select Vendor..."
            (onChange)="getSelectedVendorDetails(returnForm?.controls['vendorId']?.value?.id)" appendTo="body"
            optionLabel="name" [showClear]="true" formControlName="vendorId" [filter]="true"
            [disabled]="type == 'VIEW' || type == 'EDIT'"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-4"  *ngIf="isAllowPostingPeriod">
          <label>Posting Period: <span style="color: red">*</span></label>
          <app-posting-period-selector [transactionDate]="closingDate" [moduleName]="'VendorRMA'"
              [selectedPostingPeriod]="currentPostingPeriodInfo" [isViewMode]="type == 'VIEW'"
              (postingInfoChange)="onPostingInfoChange($event)">
          </app-posting-period-selector>
        </div>

      </div>
      <!-- Item information -->
      <div class="p-grid">
        <div class="p-col-12">
          <p-table [value]="selectedProductListTable" styleClass="p-datatable-gridlines p-datatable-striped"
            dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 5rem"></th>
                <ng-container *ngFor="let column of vendorReturnTemplate?.labels_table">
                  <th *ngIf="column.isChecked">
                    {{ column.labelname }}
                  </th>
                </ng-container>
                <th style="width: 5rem"></th>
                <th style="width: 3rem">
                  <span class="btnBars p-mr-0"
                    *ngIf="returnForm?.controls?.['warehouseId'].value?.id && returnForm?.controls['vendorId']?.value?.id"
                    (click)="showProductList(returnForm?.controls['vendorId']?.value?.id, returnForm?.controls?.['warehouseId'].value?.id)">
                    <i class="pi pi-plus"></i>
                  </span>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-index="rowIndex" let-expanded="expanded">
              <tr>
                <td>
                  <button type="button" pButton pRipple [pRowToggler]="product"
                    class="p-button-text p-button-rounded p-button-plain"
                    *ngIf="product?.rmaBundleDetails?.length > 0 && product?.typeId != 6"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <ng-container *ngFor="let column of vendorReturnTemplate?.labels_table">
                  <td
                    *ngIf="column.isChecked && column.code != 'returnqty' && column.code != 'returnamt' && column.code != 'bin'">
                    <ng-container *ngIf="column.code == 'rate' || column.code == 'amount'; else displayData">
                      <!-- <span *ngIf="column.code == 'amount' && product?.typeId == 4">{{ product[column.code] | currencySymbol }}</span>
                        <span *ngIf="(column.code == 'rate' || column.code == 'amount') && product?.typeId != 4">{{ product[column.code] | currencySymbol }}</span> -->
                      <span *ngIf="column.code == 'amount' && product?.typeId == 4">amount{{ product[column.code] |
                        multicurrency : (vendorExchangeRate ??
                        baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ??
                        baseCurrency?.symbol):(length) }}</span>
                      <span *ngIf="(column.code == 'rate' || column.code == 'amount') && product?.typeId != 4">{{
                        product[column.code] | multicurrency : (vendorExchangeRate ??
                        baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ??
                        baseCurrency?.symbol):(length) }}</span>
                    </ng-container>
                    <ng-template #displayData>
                      <span>{{ product[column.code] | shorten: 55 }}</span>
                    </ng-template>
                  </td>
                  <td pEditableColumn class="action" *ngIf="column.code == 'bin'">
                    <span *ngIf="product?.typeId == 1 || product?.typeId == 6">
                      <p-dropdown [options]="product?.bins" [(ngModel)]="product.binId" optionLabel="name"
                        optionValue="id" placeholder="Select Bin" class="small inlineNormalDD" appendTo="body"
                        [ngModelOptions]="{ standalone: true }"></p-dropdown>
                    </span>
                  </td>
                  <td class="action" *ngIf="column.code == 'returnqty'">
                    <span *ngIf="product?.typeId != 4">
                      <p-inputNumber [(ngModel)]="product.returnQty" mode="decimal" inputId="withoutgrouping"
                        (keypress)="checkValue($event,product)" [ngModelOptions]="{ standalone: true }"
                        [useGrouping]="false" (onBlur)="calReturnAmt(product)" [min]="0"
                        [minFractionDigits]="getDecimalPlacesCached(product?.categoryId)"
                        [maxFractionDigits]="getDecimalPlacesCached(product?.categoryId)"
                        [max]="product?.pendingRMAQty < product.qty ? product?.pendingRMAQty : product.qty"></p-inputNumber>
                    </span>
                  </td>
                  <!-- <td *ngIf="column.code == 'returnamt'">
                      {{ product?.returnAmount | customNumberFormat: length | currencySymbol }}
                    </td> -->
                  <td *ngIf="column.code == 'returnamt'">
                    {{ product?.returnAmount | multicurrency : (vendorExchangeRate ??
                    baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol):(length)
                    }}
                  </td>
                </ng-container>
                <td>
                  <span class="btnBars p-mt-2 badge" *ngIf="product?.typeId == 1 && product?.isTrackingEnabled"
                    (click)="openScanInfo(product)">
                    <i class="pi pi-th-large" pBadge
                      value="{{ product?.vendorRMAProductSerialDetail ? product?.vendorRMAProductSerialDetail?.length : 0 }}"
                      severity="warning"></i>
                  </span>
                </td>
                <td class="action">
                  <span class="btnBars p-mr-0" *ngIf="selectedProductListTable.length > 0"
                    (click)="removeProduct(index)">
                    <i class="pi pi-trash"></i>
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-product>
              <ng-container *ngFor="let row of vendorReturnTemplate?.labels_footer">
                <tr *ngIf="row.isChecked">
                  <td [attr.colspan]="footerColspan" style="text-align: right">{{ row.labelname }}:</td>
                  <!-- <td colspan="2">{{ footerData[row.code]?.toFixed(length) | currencySymbol }}</td> -->
                  <td colspan="2">{{ footerData[row.code] | multicurrency : (vendorExchangeRate ??
                    baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol):(length)
                    }}</td>
                  <!-- <td colspan="2">{{ footerData[row.code] | multicurrency : (vendorExchangeRate ?? baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol):(length)  }}</td> -->
                </tr>
              </ng-container>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <label>{{ vendorReturnTemplate?.labels_message[1]?.labelname }} <span style="color: red">*</span></label>
          <p-dropdown [options]="allReasons" placeholder="Select a Reason" appendTo="body" optionLabel="name"
            formControlName="rmaReasonId" [showClear]="true"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-6">
          <label>{{ vendorReturnTemplate?.labels_message[2]?.labelname }}</label>
          <p-fileUpload #fileUpload name="demo[]" [customUpload]="true" [auto]="false"
            (onSelect)="saveSelectedAttachments($event)" (onRemove)="removeSelectedAttachment($event)"
            (uploadHandler)="uploadAttachments($event)" (onUpload)="onUpload($event)" multiple="multiple"
            accept="image/*" maxFileSize="1000000">
            <ng-template pTemplate="content">
              <ng-container *ngIf="uploadedFiles?.length > 0">
                <ng-container *ngFor="let file of uploadedFiles; let i = index">
                  <div class="p-fileupload-row">
                    <button type="button" pButton icon="fa fa-download" (click)="downloadFile(file.attachmentUrl)"
                      class="p-button-link p-px-0 p-py-0" label=""></button>
                    <ng-container *ngIf="file.attachmentName?.length > 15; else splitImageName"> <img
                        [src]="file.attachmentUrl" class="imagePreview" /> {{ file.attachmentName?.substring(0, 14)
                      }}... </ng-container>
                    <ng-template #splitImageName> <img [src]="file.attachmentUrl" class="imagePreview" /> {{
                      file.attachmentName }} </ng-template>
                    <div>
                      <button icon="pi pi-times" pButton (click)="deleteImage(file.attachmentId)" type="button"
                        icon="pi pi-times"></button>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-template>
          </p-fileUpload>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <label>{{ vendorReturnTemplate?.labels_message[0]?.labelname }}</label>
          <textarea placeholder="Write details about the return here..." rows="5" cols="30"
            formControlName="description" pInputTextarea></textarea>
        </div>
      </div>
      <p-tabView class="no-padding">
        <p-tabPanel *ngIf="vendorreturn_other1.length > 0" header="other1">
          <div class="card" *ngIf="vendorreturn_other1.length > 0">
            <div class="p-field p-formgrid p-grid">
              <ng-container *ngFor="let field of vendorreturn_other1; let i = index">
                <ng-container [ngSwitch]="field.formControl.name">
                  <ng-container *ngSwitchCase="'InputBox'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <input pInputText type="text"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''"
                        name="input-{{ i }}" #input="ngModel" [(ngModel)]="field.value"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DropDownList'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-dropdown [options]="field.pickListValues" [id]="'cf_info' + i" class="small inlineNormalDD"
                        [showClear]="true" [filter]="true" [name]="'cf_info' + i" [placeholder]="'Select ' + field.name"
                        optionLabel="name" dataKey="name" [(ngModel)]="field.value"
                        [ngModelOptions]="{ standalone: true }" appendTo="body"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDropdown' : ''"></p-dropdown>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'MultipleDropDownList'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-multiSelect [options]="field.pickListValues" [id]="'cf_info' + i" [name]="'cf_info' + i"
                        [placeholder]="'Select ' + field.name" optionLabel="name" dataKey="name"
                        [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }" appendTo="body"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customMultiSelect' : ''">
                      </p-multiSelect>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CheckBox'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <ng-container *ngFor="let opt of field.pickListValues; let j = index"> <p-checkbox
                          [name]="'cf_chkbx' + i" [value]="opt.name" [(ngModel)]="field.value"
                          [ngModelOptions]="{ standalone: true }"
                          [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customCheckbox' : ''">
                        </p-checkbox> {{ opt.name }} </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'FileUpload'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-fileUpload #refFile name="myfile[]" customUpload="true"
                        (onSelect)="onCustomUpload($event.files, field, refFile)" multiple="multiple" accept="image/*"
                        maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                          <ul *ngIf="field.customUploadedFiles.length">
                            <li *ngFor="let file of field.customUploadedFiles; let index = index">
                              {{ file.name }} - {{ file.size }} bytes
                              <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field, index)"
                                icon="pi pi-times"></button>
                            </li>
                          </ul>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Picture'">
                    <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-fileUpload #refFile name="myfile[]" customUpload="true"
                        (onSelect)="onCustomUpload($event.files, field, refFile)" multiple="multiple" accept="image/*"
                        maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                          <ul *ngIf="field.customUploadedFiles.length">
                            <li *ngFor="let file of field.customUploadedFiles; let index = index">
                              {{ file.name }} - {{ file.size }} bytes
                              <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field, i)"
                                icon="pi pi-times"></button>
                            </li>
                          </ul>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'RadioButton'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <ng-container *ngFor="let opt of field.pickListValues; let j = index"> <p-radioButton
                          [name]="'cf_rdo' + i" [value]="opt.name" [(ngModel)]="field.value"
                          [ngModelOptions]="{ standalone: true }"
                          [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customRadioButton' : ''">
                        </p-radioButton>&nbsp;{{ opt.name }} </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Rating'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customRating' : ''"></p-rating>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'ToggleButton'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2" style="width: 60%"><span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-toggleButton class="p-mb-2" onLabel="{{ field.labelname }}"
                        [ngModelOptions]="{ standalone: true }" offLabel="{{ field.labelname }}"
                        [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field, $event)" [offIcon]="'pi pi-times'"
                        iconPos="right" [(ngModel)]="field.value"> </p-toggleButton>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DatePicker'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2" style="width: 60%">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDatePicker' : ''"></p-calendar>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Decimal'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                        [maxFractionDigits]="field?.maxLengthAfterDecimal || 6"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDecimal' : ''"
                        [ngModelOptions]="{ standalone: true }" (keypress)="isNumberKey($event)"> </p-inputNumber>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Number'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <input pInputText type="text" (keypress)="isNumberKey($event)"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''"
                        [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other1)">*</span></label>
                      <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''" />
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel *ngIf="vendorreturn_other2.length > 0" header="other2">
          <div class="card" *ngIf="vendorreturn_other2.length > 0">
            <div class="p-field p-formgrid p-grid">
              <ng-container *ngFor="let field of vendorreturn_other2">
                <ng-container [ngSwitch]="field.formControl.name">
                  <ng-container *ngSwitchCase="'InputBox'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <input pInputText type="text"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''"
                        name="input-{{ i }}" #input="ngModel" [(ngModel)]="field.value"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DropDownList'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-dropdown [options]="field.pickListValues" [id]="'cf_info' + i" [showClear]="true"
                        [filter]="true" [name]="'cf_info' + i" [placeholder]="'Select ' + field.name"
                        class="small inlineNormalDD" optionLabel="name" dataKey="name" [(ngModel)]="field.value"
                        [ngModelOptions]="{ standalone: true }" appendTo="body"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDropdown' : ''"></p-dropdown>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'MultipleDropDownList'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-multiSelect [options]="field.pickListValues" [id]="'cf_info' + i" [name]="'cf_info' + i"
                        [placeholder]="'Select ' + field.name" optionLabel="name" dataKey="name"
                        [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }" appendTo="body"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customMultiSelect' : ''">
                      </p-multiSelect>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CheckBox'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <ng-container *ngFor="let opt of field.pickListValues; let j = index"> <p-checkbox
                          [name]="'cf_chkbx' + i" [value]="opt.name" [(ngModel)]="field.value"
                          [ngModelOptions]="{ standalone: true }"
                          [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customCheckbox' : ''">
                        </p-checkbox> {{ opt.name }} </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'FileUpload'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-fileUpload #refFile name="myfile[]" customUpload="true"
                        (onSelect)="onCustomUpload($event.files, field, refFile)" multiple="multiple" accept="image/*"
                        maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                          <ul *ngIf="field.customUploadedFiles.length">
                            <li *ngFor="let file of field.customUploadedFiles; let index = index">
                              {{ file.name }} - {{ file.size }} bytes
                              <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field, index)"
                                icon="pi pi-times"></button>
                            </li>
                          </ul>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Picture'">
                    <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-fileUpload #refFile name="myfile[]" customUpload="true"
                        (onSelect)="onCustomUpload($event.files, field, refFile)" multiple="multiple" accept="image/*"
                        maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                          <ul *ngIf="field.customUploadedFiles.length">
                            <li *ngFor="let file of field.customUploadedFiles; let index = index">
                              {{ file.name }} - {{ file.size }} bytes
                              <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field, index)"
                                icon="pi pi-times"></button>
                            </li>
                          </ul>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'RadioButton'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <ng-container *ngFor="let opt of field.pickListValues; let j = index"> <p-radioButton
                          [name]="'cf_rdo' + i" [value]="opt.name" [(ngModel)]="field.value"
                          [ngModelOptions]="{ standalone: true }"
                          [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customRadioButton' : ''">
                        </p-radioButton>&nbsp;{{ opt.name }} </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Rating'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customRating' : ''"></p-rating>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'ToggleButton'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2" style="width: 60%"><span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-toggleButton class="p-mb-2" onLabel="{{ field.labelname }}" offLabel="{{ field.labelname }}"
                        [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field, $event)" [offIcon]="'pi pi-times'"
                        iconPos="right" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }">
                      </p-toggleButton>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DatePicker'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2" style="width: 60%">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDatePicker' : ''"></p-calendar>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Decimal'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                        [maxFractionDigits]="field?.maxLengthAfterDecimal || 6"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDecimal' : ''"
                        [ngModelOptions]="{ standalone: true }" (keypress)="isNumberKey($event)"> </p-inputNumber>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Number'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <input pInputText type="text" (keypress)="isNumberKey($event)"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''"
                        [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other2)">*</span></label>
                      <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''" />
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel *ngIf="vendorreturn_other3.length > 0" header="other3">
          <div class="card" *ngIf="vendorreturn_other3.length > 0">
            <div class="p-field p-formgrid p-grid">
              <ng-container *ngFor="let field of vendorreturn_other3">
                <ng-container [ngSwitch]="field.formControl.name">
                  <ng-container *ngSwitchCase="'InputBox'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <input pInputText type="text"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''"
                        name="input-{{ i }}" #input="ngModel" [(ngModel)]="field.value"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DropDownList'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-dropdown [options]="field.pickListValues" [id]="'cf_info' + i" [showClear]="true"
                        [filter]="true" [name]="'cf_info' + i" [placeholder]="'Select ' + field.name"
                        class="small inlineNormalDD" optionLabel="name" dataKey="name" [(ngModel)]="field.value"
                        [ngModelOptions]="{ standalone: true }" appendTo="body"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDropdown' : ''"></p-dropdown>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'MultipleDropDownList'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-multiSelect [options]="field.pickListValues" [id]="'cf_info' + i" [name]="'cf_info' + i"
                        [placeholder]="'Select ' + field.name" optionLabel="name" dataKey="name"
                        [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }" appendTo="body"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customMultiSelect' : ''">
                      </p-multiSelect>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CheckBox'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <ng-container *ngFor="let opt of field.pickListValues; let j = index"> <p-checkbox
                          [name]="'cf_chkbx' + i" [value]="opt.name" [(ngModel)]="field.value"
                          [ngModelOptions]="{ standalone: true }"
                          [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customCheckbox' : ''">
                        </p-checkbox> {{ opt.name }} </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'FileUpload'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-fileUpload #refFile name="myfile[]" customUpload="true"
                        (onSelect)="onCustomUpload($event.files, field, refFile)" multiple="multiple" accept="image/*"
                        maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                          <ul *ngIf="field.customUploadedFiles.length">
                            <li *ngFor="let file of field.customUploadedFiles; let index = index">
                              {{ file.name }} - {{ file.size }} bytes
                              <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field, index)"
                                icon="pi pi-times"></button>
                            </li>
                          </ul>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Picture'">
                    <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-fileUpload #refFile name="myfile[]" customUpload="true"
                        (onSelect)="onCustomUpload($event.files, field, refFile)" multiple="multiple" accept="image/*"
                        maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                          <ul *ngIf="field.customUploadedFiles.length">
                            <li *ngFor="let file of field.customUploadedFiles; let index = index">
                              {{ file.name }} - {{ file.size }} bytes
                              <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field, index)"
                                icon="pi pi-times"></button>
                            </li>
                          </ul>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'RadioButton'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <ng-container *ngFor="let opt of field.pickListValues; let j = index"> <p-radioButton
                          [name]="'cf_rdo' + i" [value]="opt.name" [(ngModel)]="field.value"
                          [ngModelOptions]="{ standalone: true }"
                          [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customRadioButton' : ''">
                        </p-radioButton>&nbsp;{{ opt.name }} </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Rating'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customRating' : ''"></p-rating>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'ToggleButton'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2" style="width: 60%"><span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-toggleButton class="p-mb-2" onLabel="{{ field.labelname }}" offLabel="{{ field.labelname }}"
                        [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field, $event)" [offIcon]="'pi pi-times'"
                        iconPos="right" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }">
                      </p-toggleButton>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DatePicker'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2" style="width: 60%">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDatePicker' : ''"></p-calendar>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Decimal'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                        [maxFractionDigits]="field?.maxLengthAfterDecimal || 6"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customDecimal' : ''"
                        [ngModelOptions]="{ standalone: true }" (keypress)="isNumberKey($event)"> </p-inputNumber>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Number'">
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <input pInputText type="text" (keypress)="isNumberKey($event)"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''"
                        [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                      <label class="p-mb-2">{{ field.labelname }}<span style="color: red"
                          *ngIf="checkRequired(field.name, vendorreturn_other3)">*</span></label>
                      <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"
                        [ngClass]="field.isRequired && applyValidation && (field.value == null || field.value == '') ? 'customValidation' : ''" />
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton class="p-button-label" (click)="save(returnForm?.value)" label="Save"
      [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) || type == 'VIEW' || !returnForm?.valid || isDisabledSaveBtn || selectedProductListTable?.length == 0 || !returnForm?.controls?.['vendorId']?.value || !!statementMessege"></button>
  </p-footer>
</p-dialog>
<!-- Select Product -->
<p-dialog [showHeader]="false" [(visible)]="displayList" [modal]="true" [responsive]="true" [style]="{ width: '60vw' }">
  <div class="header">
    <div class="p-grid">
      <div class="p-col-12 p-md-4">
        <label>Search By <span style="color: red">*</span></label>
        <p-dropdown [options]="searchBy" placeholder="Select an Option" appendTo="body" optionLabel="name"
          [disabled]="hasSelectedProduct" (onChange)="onSearchByChange($event)"
          [(ngModel)]="selectedSearch"></p-dropdown>
      </div>
      <div class="p-col-12 p-md-4" *ngIf="selectedSearch?.name == 'Bill No.'">
        <label>Bill <span style="color: red">*</span></label>
        <p-dropdown [options]="allBills" placeholder="Select an Bill" appendTo="body" optionLabel="name"
          (onChange)="onChangeBill($event)" [disabled]="disableBillChange" [showClear]="true" [(ngModel)]="selectedBill"
          [filter]="true"></p-dropdown>
      </div>
      <div class="p-col-12 p-md-4" *ngIf="selectedSearch?.name == 'Serial No.'">
        <label>Serial No. <span style="color: red">*</span></label>
        <p-autoComplete [(ngModel)]="selectedSerialNumber" [disabled]="disableSerialNumberInput" [virtualScroll]="true"
          [virtualScrollItemSize]="30" [suggestions]="serialNumberSuggestions"
          (onSelect)="onSerialNumberBillSelect($event.value)" (completeMethod)="onSerialNumberInput($event)"
          placeholder="Enter serial number..." [minLength]="1"></p-autoComplete>
      </div>
      <div class="p-col-12 p-md-4" *ngIf="selectedSearch?.name == 'Item No.'">
        <label>Item No. <span style="color: red">*</span></label>
        <p-autoComplete [(ngModel)]="selectedItemNumber" [disabled]="disableItemNumberInput" [virtualScroll]="true"
          [virtualScrollItemSize]="30" [suggestions]="itemNumberSuggestions"
          (onSelect)="onItemNumberBillSelect($event.value)" (completeMethod)="onItemNumberInput($event)"
          placeholder="Enter item number..." [minLength]="1"></p-autoComplete>
      </div>
    </div>
  </div>
  <div class="card">
    <p-table [value]="billItems" selectionMode="multiple" [(selection)]="selectedProducts"
      (onRowSelect)="toggleBillDropdown($event)" (onRowUnselect)="toggleBillDropdown($event)" dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let column of billItemsSection">
            <ng-container *ngIf="column.isChecked">
              <ng-container *ngIf="column.code == 'billNo'; else displayHeader">
                <th *ngIf="showBillNumber">
                  {{ column.labelname }}
                </th>
              </ng-container>
              <ng-template #displayHeader>
                <th>{{ column.labelname }}</th>
              </ng-template>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
        <tr [pSelectableRow]="product" [pSelectableRowIndex]="rowIndex">
          <ng-container *ngFor="let column of billItemsSection">
            <ng-container *ngIf="column.isChecked">
              <ng-container *ngIf="column.code == 'billNo'; else displayItemData">
                <td *ngIf="showBillNumber">
                  {{ product[column.code] }}
                </td>
              </ng-container>
              <ng-template #displayItemData>
                <td
                  *ngIf="column.code == 'amount' || column.code == 'rate' || column.code == 'originalPrice' || column.code == 'shippingPerPrice' || column.code == 'taxPerPrice' || column.code == 'discountPerPrice'">
                  <!-- {{ product[column.code] | currencySymbol }} -->
                  {{ product[column.code] | multicurrency : (vendorExchangeRate ??
                  baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol):(length) }}
                </td>
                <td
                  *ngIf="column.code != 'amount' && column.code != 'rate' && column.code != 'originalPrice' && column.code != 'shippingPerPrice' && column.code != 'taxPerPrice' && column.code != 'discountPerPrice'">
                  {{ product[column.code] }}
                </td>
              </ng-template>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer" *ngIf="'billItems.length > 0'">
        <tr>
          <td [attr.colspan]="selectedSearch?.name === 'Bill No.' ? '6' : '7'" class="p-text-right">Subtotal:</td>
          <td [attr.colspan]="selectedSearch?.name === 'Bill No.' ? '2' : '1'" class="p-text-right">{{ subtotal |
            multicurrency : (vendorExchangeRate ?? baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ??
            baseCurrency?.symbol):(length) }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayList = false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton class="p-button-label" [disabled]="!selectedProducts.length" label="Save"
      (click)="saveList()"></button>
  </p-footer>
</p-dialog>
<!-- Tracking Information -->
<p-dialog header="Tracking Information" [(visible)]="displayScanInfo" [modal]="true" [responsive]="true"
  [closable]="false" [style]="{ width: '70vw' }">
  <form [formGroup]="trackingForm" (onHide)="prepareTrackingForm()">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <div class="p-d-flex p-jc-between w-100">
            <label>Qty<span style="color: red;">*</span></label>
            <label>{{ listLength }} / {{ selectedProductForScan?.returnQty }}</label>
          </div>
          <input pInputText type="text" id="lot" name="lot" formControlName="qty" onlyNumber />
        </div>
        <div class="p-col-12 p-lg-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'lotChecked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("lotChecked", trackingOptions, "label") }}<span style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('lotChecked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('lotChecked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText type="text" id="lot" name="lot" formControlName="lotNo" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber id="lot" name="lot" formControlName="lotNo" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="lotNo"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" id="lot" name="lot" appDecimalNumber formControlName="lotNo"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'lotChecked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'revisionChecked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("revisionChecked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('revisionChecked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('revisionChecked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText type="text" id="revision" name="revision" formControlName="revisionNo" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber id="revision" name="revision" formControlName="revisionNo" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="revisionNo"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" id="revision" name="revision" appDecimalNumber formControlName="revisionNo"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'revisionChecked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'expirationChecked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("expirationChecked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('expirationChecked', trackingOptions)">*</span></label>
          <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
            dateFormat="mm/dd/yy" yearRange="1900:2100" [minDate]="minimumDate"
            formControlName="expiration"></p-calendar>
        </div>
      </div>
      <div>
        <hr />
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serializedChecked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serializedChecked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serializedChecked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serializedChecked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'Decimal'">
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serializedChecked')" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" name="number" id="number" onlyNumber formControlName="serialNo"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText name="number" id="number" formControlName="serialNo"
                (keydown.enter)="countNameList(trackingForm?.value)" [readonly]="isAutoGenerated" />
              <div
                *ngIf="trackingForm?.controls?.['serialNo'].invalid && (trackingForm?.controls?.['serialNo'].dirty || trackingForm?.controls?.['serialNo'].touched)"
                class="p-invalid">
                <div *ngIf="trackingForm?.controls?.['serialNo'].errors.pattern">Only alphanumeric characters are
                  allowed.</div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial2Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial2Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial2Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial2Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo2"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" name="number" id="number" onlyNumber formControlName="serialNo2"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo2"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo2"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial2Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial3Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial3Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial3Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial3Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo3"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo3"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo3"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo3"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial3Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial4Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial4Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial4Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial4Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo4"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo4"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo4"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo4"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial4Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial5Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial5Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial5Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial5Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo5"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo5"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo5"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo5"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial5Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial6Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial6Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial6Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial6Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo6"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" name="number" id="number" onlyNumber formControlName="serialNo6"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo6"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo6"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial6Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial7Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial7Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial7Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial7Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo7"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo7"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo7"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo7"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial7Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial8Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial8Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial8Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial8Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo8"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo8"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo8"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo8"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial8Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial9Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial9Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial9Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial9Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo9"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo9"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo9"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo9"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial9Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial10Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial10Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial10Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial10Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo10"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo10"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo10"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo10"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial10Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial11Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial11Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial11Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial11Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo11"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo11"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo11"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo11"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial11Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial12Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial12Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial12Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial12Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo12"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" name="number" id="number" onlyNumber formControlName="serialNo12"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo12"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo12"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial12Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial13Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial13Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial13Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial13Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo13"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo13"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo13"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo13"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial13Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial14Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial14Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial14Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial14Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo14"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo14"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo14"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo14"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial14Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial15Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial15Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial15Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial15Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo15"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo15"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo15"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo15"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial15Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial16Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial16Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial16Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial16Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo16"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo16"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo16"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo16"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial16Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-2"
          *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial17Checked', productSerialSettings)">
          <label>{{ utilityServiceObj?.displayName("serial17Checked", trackingOptions, "label") }}<span
              style="color: red"
              *ngIf="utilityServiceObj?.checkRequiredValidation('serial17Checked', trackingOptions)">*</span></label>
          <ng-container [ngSwitch]="utilityServiceObj?.displayName('serial17Checked', trackingOptions, 'control')">
            <ng-container *ngSwitchCase="'InputBox'">
              <input pInputText name="number" id="number" formControlName="serialNo17"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <input pInputText type="text" onlyNumber name="number" id="number" formControlName="serialNo17"
                (keydown.enter)="countNameList(trackingForm?.value)" />
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                dateFormat="mm/dd/yy" yearRange="1900:2100" formControlName="serialNo17"></p-calendar>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input pInputText type="text" name="number" id="number" appDecimalNumber formControlName="serialNo17"
                (keydown.enter)="countNameList(trackingForm?.value)"
                [length]="utilityServiceObj?.getDecimalValue(trackingOptions, 'serial17Checked')" />
            </ng-container>
          </ng-container>
        </div>
        <div class="p-col-12 p-md-3">
          <button type="button" pButton label="Add" class="p-mt-5 p-ml-2" (click)="countNameList(trackingForm?.value)"
            [disabled]="!trackingForm.valid || (selectedProductForScan && nameLists && nameLists.length >= selectedProductForScan?.returnQty)"></button>
          <button type="button" pButton icon="pi pi-upload" (click)="openImport()" class="p-mt-5 p-ml-3"></button>
          <button type="button" pButton icon="pi pi-eye" (click)="openTracking()" class="p-mt-5 p-ml-3"></button>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <p-table [value]="nameLists" class="w-100" [lazy]="true" [paginator]="true" [first]="first"
          [totalRecords]="totalTBRecord" [rows]="pageSize" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadSerialsLazy($event)">
          <ng-template pTemplate="header">
            <tr>
              <th id="lot"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'lotChecked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("lotChecked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('lotChecked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span *ngIf="utilityServiceObj?.displayName('lotChecked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("lotChecked", trackingOptions, "currency") }})</span>
              </th>
              <th id="revision"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'revisionChecked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("revisionChecked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('revisionChecked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('revisionChecked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("revisionChecked", trackingOptions, "currency") }})</span>
              </th>
              <th id="expiration"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'expirationChecked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("expirationChecked", trackingOptions, "label") }}
              </th>
              <th id="serialNo"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serializedChecked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serializedChecked", trackingOptions, "label") }}
              </th>
              <th id="serialNo2"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial2Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial2Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial2Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial2Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial2Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo3"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial3Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial3Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial3Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial3Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial3Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo4"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial4Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial4Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial4Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial4Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial4Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo5"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial5Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial5Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial5Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial5Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial5Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo6"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial6Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial6Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial6Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial6Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial6Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo7"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial7Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial7Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial7Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial7Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial7Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo8"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial8Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial8Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial8Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial8Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial8Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo9"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial9Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial9Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial9Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial9Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial9Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo10"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial10Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial10Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial10Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial10Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial10Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo11"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial11Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial11Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial11Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial11Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial11Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo12"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial12Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial12Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial12Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial12Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial12Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo13"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial13Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial13Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial13Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial13Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial13Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo14"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial14Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial14Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial14Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial14Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial14Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo15"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial15Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial15Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial15Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial15Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial15Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo16"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial16Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial16Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial16Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial16Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial16Checked", trackingOptions, "currency") }})</span>
              </th>
              <th id="serialNo17"
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial17Checked', productSerialSettings)">
                {{ utilityServiceObj?.displayName("serial17Checked", trackingOptions, "label") }}
                <span
                  *ngIf="utilityServiceObj?.displayName('serial17Checked', trackingOptions, 'control') == 'Percentage'">(%)</span>
                <span
                  *ngIf="utilityServiceObj?.displayName('serial17Checked', trackingOptions, 'control') == 'Currency'">({{
                  utilityServiceObj?.displayName("serial17Checked", trackingOptions, "currency") }})</span>
              </th>
              <th *ngIf="serialConfig?.enabled">Matched</th>
              <th style="width: 2rem">
                <p-checkbox binary="true" [(ngModel)]="allChecked" (onChange)="setTableCheck()"
                  [ngModelOptions]="{ standalone: true }"></p-checkbox>
              </th>
              <th style="width: 3rem" *ngIf="allChecked">
                <span class="btnBars p-mt-0" (click)="deleteAll()">
                  <i class="pi pi-trash" pTooltip="Delete All" tooltipPosition="top"></i>
                </span>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-i="rowIndex">
            <tr>
              <td *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'lotChecked', productSerialSettings)">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('lotChecked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.lotNo }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.lotNo && product?.lotNo | date: "MM/dd/yyyy"
                    }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'revisionChecked', productSerialSettings)">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('revisionChecked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.revisionNo }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.revisionNo && product?.revisionNo | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'expirationChecked', productSerialSettings)">
                {{ product?.expiration | date: "MM/dd/yyyy" }}
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serializedChecked', productSerialSettings)"
                style="word-break: break-all">
                {{ product?.serialNo }}
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial2Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial2Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo2 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo2 && product?.serialNo2 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial3Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial3Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo3 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo3 && product?.serialNo3 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial4Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial4Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo4 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo4 && product?.serialNo4 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial5Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial5Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo5 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo5 && product?.serialNo5 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial6Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial6Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo6 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo6 && product?.serialNo6 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial7Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial7Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo7 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo7 && product?.serialNo7 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial8Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial8Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo8 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo8 && product?.serialNo8 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial9Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial9Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo9 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo9 && product?.serialNo9 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial10Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial10Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo10 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo10 && product?.serialNo10 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial11Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial11Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo11 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo11 && product?.serialNo11 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial12Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial12Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo12 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo12 && product?.serialNo12 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial13Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial13Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo13 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo13 && product?.serialNo13 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial14Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial14Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo14 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo14 && product?.serialNo14 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial15Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial15Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo15 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo15 && product?.serialNo15 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial16Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial16Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo16 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo16 && product?.serialNo16 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td
                *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, 'serial17Checked', productSerialSettings)"
                style="word-break: break-all">
                <ng-container
                  *ngIf="utilityServiceObj?.displayName('serial17Checked', trackingOptions, 'control') as controlType">
                  <span *ngIf="controlType !== 'DatePicker'">{{ product?.serialNo17 }}</span>
                  <span *ngIf="controlType === 'DatePicker'">{{ product?.serialNo17 && product?.serialNo17 | date:
                    "MM/dd/yyyy" }}</span>
                </ng-container>
              </td>
              <td *ngIf="serialConfig?.enabled">
                <span *ngIf="product?.systemPresent"><i class="pi pi-check"
                    style="font-size: 1.5rem; color: green"></i></span>
                <span *ngIf="!product?.systemPresent"><i class="pi pi-times"
                    style="font-size: 1.5rem; color: red"></i></span>
              </td>
              <td>
                <p-checkbox [value]="product" (onChange)="setMainHeaderTracking()" [(ngModel)]="product.checked"
                  [ngModelOptions]="{ standalone: true }" binary="true"> </p-checkbox>
              </td>
              <td class="action">
                <span class="btnBars p-mt-0" *ngIf="product?.checked" (click)="removeNumber(i)">
                  <i class="pi pi-trash"></i>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayScanInfo = false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton class="p-button-label" label="Save"
      (click)="saveSerializedNo(trackingForm?.value)"></button>
  </p-footer>
</p-dialog>

@if(displayImport){
  <app-shared-import-series headerTitle="New Import" [display]="displayImport" [hideBulkScan]="true"
  [trackingJSON]="productSerialSettings" [importCount]="selectedProductForScan?.returnQty - listLength"
  [trackingOptions]="trackingOptions" [importForAllProducts]="importForAllProducts" [fromPO]="false"
  [disabledSave]="disabledSave"  [savedData]="autoGenerateLists" (onSave)="importSave($event)" 
  (cancelClicked)="hideImport()"></app-shared-import-series>
}

@if(displayTracking){
  <app-viewtracking [productSerialSettings]="productSerialSettings" [trackingOptions]="trackingOptions"
   [displayTracking]="displayTracking" [productId]="selectedProductForScan?.productId" [isReturn]="true"
   [warehouseId]="returnForm?.controls?.['warehouseId'].value?.id" [billId]="selectedProductForScan?.billOrderId" 
   (onClose)="closeTracking()" (onSubmit)="saveTracking($event)">
  </app-viewtracking>
}

<!-- closing statement -->
<ng-container *ngIf="closingDate && type != 'VIEW'">
  <app-closing-statement-validation 
    [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : closingDate" 
    [moduleName]="'VendorRMA'" (isClosingStatementDate)="isClosingStatementDate($event)">
  </app-closing-statement-validation>
</ng-container>